import React from 'react'

export default function TableSortAscend(props) {
  return (
    <svg
      width={props.width ? props.width : '10'}
      height={props.height ? props.height : '8'}
      viewBox='0 0 10 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='1'>
        <path
          d='M0.834661 8C0.160459 8 -0.221747 7.099 0.138166 6.4506L0.19468 6.35982L4.36002 0.359816C4.67087 -0.0879545 5.22633 -0.117806 5.56979 0.270261L5.63998 0.359816L9.80532 6.35982C10.2369 6.98154 9.90499 7.9108 9.25962 7.994L9.16534 8L0.834661 8Z'
          fill={props.color ? props.color : '#FFFFFF'}
        />
      </g>
    </svg>
  )
}
